import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function PainSection() {
  return <Section dark className="border-t border-stone-200" data-id="element-113">
      <div className="text-center mb-12" data-id="element-114">
        <h2 className="text-3xl md:text-4xl font-serif text-[#2D2A26] mb-4" data-id="element-115">
          Esto no es falta de amor. <br data-id="element-116" />
          Es un patrón.
        </h2>
        <div className="w-16 h-1 bg-[#C4A35A] mx-auto mt-6" data-id="element-117"></div>
      </div>

      <div className="prose prose-lg mx-auto text-gray-700" data-id="element-118">
        <p className="mb-8" data-id="element-119">
          En parejas de larga relación, el deseo rara vez desaparece de golpe.
          <span className="font-semibold block mt-2" data-id="element-120">
            Se apaga por repetición.
          </span>
        </p>

        <ul className="space-y-4 mb-10 pl-0 list-none" data-id="element-121">
          {['Un intento que termina en rechazo.', "Un 'sí' dicho por compromiso.", 'Una conversación que se vuelve juicio.', 'Un abrazo que ya no se siente seguro.'].map((item, i) => <li key={i} className="flex items-start gap-3 bg-white p-4 rounded-sm shadow-sm" data-id="element-122">
              <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-123" />
              <span data-id="element-124">{item}</span>
            </li>)}
        </ul>

        <p className="text-xl font-serif italic text-center text-[#2D2A26] mb-16" data-id="element-125">
          "Y con el tiempo, el cuerpo aprende: mejor no empiezo. O peor:
          empiezo, pero con resentimiento."
        </p>

        <div className="bg-white p-8 md:p-10 border-l-4 border-[#C4A35A] shadow-sm" data-id="element-126">
          <h3 className="text-2xl font-serif text-[#2D2A26] mb-4" data-id="element-127">
            El problema no es el sexo. Es la seguridad.
          </h3>
          <p className="mb-4" data-id="element-128">
            Cuando la intimidad se siente como obligación, el deseo se vuelve
            defensa.
          </p>
          <p data-id="element-129">
            Y cuando el "no" se castiga (aunque sea con cara, distancia o
            silencio), el cuerpo se cierra más.
          </p>
        </div>
      </div>
    </Section>;
}